"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatAbiItemWithArgs = void 0;
const stringify_js_1 = require("../stringify.js");
function formatAbiItemWithArgs(_ref) {
  let {
    abiItem,
    args,
    includeFunctionName = true,
    includeName = false
  } = _ref;
  if (!('name' in abiItem)) return;
  if (!('inputs' in abiItem)) return;
  if (!abiItem.inputs) return;
  return "".concat(includeFunctionName ? abiItem.name : '', "(").concat(abiItem.inputs.map((input, i) => "".concat(includeName && input.name ? "".concat(input.name, ": ") : '').concat(typeof args[i] === 'object' ? (0, stringify_js_1.stringify)(args[i]) : args[i])).join(', '), ")");
}
exports.formatAbiItemWithArgs = formatAbiItemWithArgs;
//# sourceMappingURL=formatAbiItemWithArgs.js.map